'use server'

import { apiRequest, ApiResponse } from '../request'

export interface HrRubric {
    id: number
    companyId: number
    code: string
    name: string
    type: string
    calculationType: string
    defaultValue: number | null
    formula: string | null
    incidence: any
    active: boolean
    isSystem: boolean
    createdAt: string
}

const BASE = 'hr/rubrics'

export async function getRubrics(params?: { type?: string }): Promise<ApiResponse<HrRubric[]>> {
    return apiRequest<HrRubric[]>(BASE, { params: params || {} })
}

export async function getRubric(id: number): Promise<ApiResponse<HrRubric>> {
    return apiRequest<HrRubric>(`${BASE}/${id}`, {})
}

export async function createRubric(data: any): Promise<ApiResponse<HrRubric>> {
    return apiRequest<HrRubric>(BASE, { data }, 'post')
}

export async function updateRubric(id: number, data: any): Promise<ApiResponse<HrRubric>> {
    return apiRequest<HrRubric>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteRubric(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}

export async function seedRubrics(): Promise<ApiResponse<any>> {
    return apiRequest<any>(`${BASE}/seed`, {}, 'post')
}
